<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Dados Básicos</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Nome</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input name="nome" type="text" placeholder="Nome" v-model="form.nome"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('nome') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Email</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input name="email" type="text" placeholder="Email" v-model="form.email"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('email') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Perfil</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-select
                    v-model="form.perfil"
                    :changed="changed('perfil')"
                    name="perfil"
                    id="perfil"
                  >
                    <md-option
                      v-for="item in perfis"
                      :key="item.id"
                      :value="item.id"
                    >{{item.nome}}</md-option>
                  </md-select>
                </md-field>

                <span class="error_input">{{ getErrors('perfil') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="perfil_nome != null && perfil_nome == 'Cliente'">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cliente</label>
              <div class="md-layout-item">
                <autocomplete
                  v-if="false"
                  search_method="clientes"
                  field_value="id"
                  field_text="nome"
                  :onSelect="OnSelectCliente"
                  :id_start_value="form.id_cliente"
                ></autocomplete>

                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select2"
                    :options="items_clientes"
                    v-model="form.id_cliente"
                    :searchable="true"
                    language="pt-BR"
                    :onChange="loadUnidadesByCliente"
                    :placeholder="placeholder_cliente"
                  ></vue_select>
                </md-field>
              </div>
            </div>

            <div class="md-layout" v-if="get_tipo_nome('cliente')">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Selecione as Unidades</label>
              <div class="md-layout-item">
                <checkbox_list
                  search_method="estabelecimento"
                  field_value="id"
                  field_text="nome"
                  v-model="form.unidades"
                  :items="items_unidades"
                  :show_marcatodos="true"
                  :value_marcatodos="form.todas_unidades"
                  onSelect="form.unidades = $event.target.value"
                ></checkbox_list>

                <!--    :onMarcaTodos="form.todas_unidades  = $event.value " -->
              </div>
            </div>
            <div class="md-layout" v-if="false">
              <label
                class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"
              >Selecione as Clientes / Unidades</label>
              <div class="md-layout-item">
                <add_unidades_variosclientes v-model="form.unidades"></add_unidades_variosclientes>
              </div>
            </div>

            <div class="md-layout" v-if="get_tipo_nome('técnico') || get_tipo_codigo('TEC') || get_tipo_codigo('2')">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Profissional</label>
              <div class="md-layout-item md-size-80 md-xsmall-size-70">
                <md-field>
                  <md-select
                    v-if="false"
                    v-model="form.id_profissional"
                    name="id_profissional"
                    id="id_profissional"
                  >
                    <md-option
                      v-for="item in lista_profissional"
                      :key="item.id"
                      :value="item.id"
                    >{{item.nome}}</md-option>
                  </md-select>

                  <vue_select
                    class="vue-select2"
                    name="id_profissional"
                    :options="lista_profissional"
                    v-model="form.id_profissional"
                    :searchable="true"
                    language="pt-BR"
                  ></vue_select>
                </md-field>
              </div>
            </div>

            <div class="md-layout" v-if="get_tipo_nome('supervisor') || get_tipo_nome('técnico') || get_tipo_codigo('TEC') || get_tipo_codigo('2')">
              <label
                class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"
              >Selecione os Modelos de CheckList permitidos</label>
              <div class="md-layout-item">
                <!-- :value_marcatodos="form.todas_checklists"  -->
                <checkbox_list
                  search_method="modelo_checklist"
                  field_value="id"
                  field_text="nome"
                  v-model="form.checklists"
                  :items="list_modelo_checklist"
                  :show_marcatodos="true"
                ></checkbox_list>
              </div>
            </div>

            <div class="md-layout" v-if="get_tipo_nome('comercial')">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label"></label>
              <div class="md-layout-item">
                <list_unidade_bycliente v-model="form.unidades" :id_cliente="form.id"></list_unidade_bycliente>

                <!--    :onMarcaTodos="form.todas_unidades  = $event.value " -->
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Profissional</label>
              <div class="md-layout-item">
                <md-field>
                  <md-autocomplete
                    v-model="selectProfissional"
                    :md-fuzzy-search="false"
                    :md-options="list_nome_nutricionista"
                  >
                    <label>Profissional</label>

                    <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                      <md-highlight-text :md-term="term">{{ item }}</md-highlight-text>
                    </template>

                    <template
                      slot="md-autocomplete-empty"
                      slot-scope="{ term }"
                    >No employees matching "{{ term }}" were found.</template>
                  </md-autocomplete>
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Data Cadastro</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                {{form.data_cadastro | date_show}}
                <span
                  class="error_input"
                >{{ getErrors('data_cadastro') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Login</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input name="login" type="text" placeholder="Login" v-model="form.login"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('login') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Senha</label>
              <div class="md-layout-item md-size-40 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="senha"
                    v-if="show_senha"
                    type="text"
                    placeholder="Senha"
                    v-model="form.senha"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('senha') }}</span>
              </div>
              <div class="md-layout-item md-size-20 md-xsmall-size-100">
                <md-button
                  class="md-info"
                  type="button"
                  v-on:click="gerar_nova_senha"
                >Gerar Nova Senha</md-button>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Observações</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-textarea v-model="form.obs" name="obs" id="obs" style="height: 120px"></md-textarea>
                </md-field>

                <span class="error_input">{{ getErrors('obs') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">id_profissional</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_profissional_old"
                    type="text"
                    placeholder="id_profissional_old"
                    v-model="form.id_profissional"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_profissional') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cliente</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_cliente"
                    type="text"
                    placeholder="Cliente"
                    v-model="form.id_cliente"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_cliente') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">todas_unidades</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="todas_unidades"
                    type="text"
                    placeholder="todas_unidades"
                    v-model="form.todas_unidades"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('todas_unidades') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">unidades</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="unidades"
                    type="text"
                    placeholder="unidades"
                    v-model="form.unidades"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('unidades') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">checklists</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="checklists"
                    type="text"
                    placeholder="checklists"
                    v-model="form.checklists"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('checklists') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">todas_checklists</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="todas_checklists"
                    type="text"
                    placeholder="todas_checklists"
                    v-model="form.todas_checklists"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('todas_checklists') }}</span>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <cardcadastro
        v-if="get_tipo_nome('franquia') || get_tipo_nome('supervisor')  || get_tipo_nome('técnico') || get_tipo_nome('agente comercial') || get_tipo_codigo('TEC') || get_tipo_codigo('2')"
      >
        <div slot="header">
          <h4 class="title">Unidades</h4>
        </div>

        <div slot="body">
          <add_unidades_variosclientes v-model="form.unidades"></add_unidades_variosclientes>
        </div>
      </cardcadastro>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar()"
          >Salvar</md-button>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir()"
          >Excluir</md-button>
        </div>
      </div>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/UsuarioService";
import serviceCadastro from "../../../services/CadastroBasicoService";
import serviceCliente from "../../../services/ClienteService";
import serviceUnidade from "../../../services/EstabelecimentoService";
import serviceNutricionista from "../../../services/NutricionistaService";
import serviceModeloCheckList from "../../../services/ModeloChecklistService";
import PerfilAcessoService from "../../../services/PerfilAcessoService";

import checkbox_list from "../../components/checkbox_list";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import list_unidade_bycliente from "../estabelecimento/list_unidade_bycliente";
import add_unidades_variosclientes from "../estabelecimento/add_unidades_variosclientes";
import cardcadastro from "../../../components/CardCadastro.vue";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import Util from "../../../library/Util";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    checkbox_list,
    list_unidade_bycliente,
    add_unidades_variosclientes,
    cardcadastro,
    vue_select
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],
      items_unidades: [],
      items_clientes: [],

      lista_profissional: [],

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      show_senha: true,
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,

      show_autocompletes: true,
      //selectProfissional list_nome_nutricionista
      selectProfissional: "",
      list_nome_nutricionista: [],
      list_modelo_checklist: [],

      perfil_nome: null,
      perfil_id: "",
      perfil_codigo: null,

      placeholder_cliente: "..Carregando clientes"
    };
  },
  mounted() {
    let self = this;
    this.form = service.getModel();

    serviceCliente.getList2("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(
        response.data.data,
        "id",
        "nome"
      );

      self.placeholder_cliente = "Cliente (digite para pesquisar) ";
    });
    /*serviceCadastro.getList("", 1, "descricao", "asc").then(function(response) {
      self.perfis = response.data;
      self.show_perfil = true;
    });*/
    PerfilAcessoService.getList("", "nome", "asc").then(function(response) {
      self.perfis = response.data;
      self.show_perfil = true;
    });


    serviceNutricionista.getList("", "nome", "asc").then(function(response) {
      self.lista_profissional = Util.getListToSelect(
        response.data,
        "id",
        "nome"
      );
    });

    serviceModeloCheckList
      .getList({ order: "nome", order_type: "asc" })
      .then(function(response) {
        self.list_modelo_checklist = response.data;
      });

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;
    self.show_autocompletes = false;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service.getById(this.id_load).then(function(response) {
        if (response.data.data != null && response.data.data != undefined) {
          self.form = response.data.data;
        } else {
          self.form = response.data.item;
        }
        self.loadUnidadesByCliente();

        if (self.form.perfil != null) {
          self.form.perfil = parseInt(self.form.perfil);
        }
        self.loading = false;
        self.disableButton = false;
        self.show_autocompletes = true;
      });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "usuario",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    generatePassword(length) {
      //var length = 8,
      console.log("vou gerar password? " + length);
      var charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      console.log(" password? " + retVal);
      return retVal;
    },

    gerar_nova_senha() {
      let self = this;
      this.show_senha = false;
      setTimeout(function() {
        self.form.senha = self.generatePassword(6);
        self.show_senha = true;
      }, 50);
    },

    get_tipo_nome(tipo) {
      if (this.perfil_nome == null) return false;

      return (
        this.perfil_nome
          .toString()
          .toLowerCase()
          .indexOf(tipo) > -1
      );
    },
    get_tipo_codigo(tipo) {
      if (this.perfil_codigo == null) return false;

      return (
        this.perfil_codigo == tipo
      );
    },
    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {
      if (
        prop == "perfil" &&
        this.form.perfil != undefined &&
        this.perfil_id.toString() != this.form.perfil.toString()
      ) {
        var self = this;
        this.perfil_nome = null;

        var filter = this.perfis.filter(function(item) {
          return item.id.toString() == self.form.perfil.toString();
        });
        //console.log("Filter?? " + self.form.perfil +" " +  filter.length );
        if (filter.length > 0) {
          this.perfil_nome = filter[0].nome;
          this.perfil_id = filter[0].id;
          this.perfil_codigo = filter[0].codigo;
        }
      }
    },
    loadUnidadesByCliente() {
      var self = this;

      if (this.form.id_cliente == null || this.form.id_cliente == undefined) {
        return false;
      }

      serviceUnidade
        .getListByParent("cliente", this.form.id_cliente)
        .then(function(response) {
          self.items_unidades = response.data;
        });
    },
    OnSelectCliente(item) {
      var self = this;

      if (item != null && item.id != null) {
        this.form.id_cliente = item.id;
        this.loadUnidadesByCliente();
      } else {
        this.form.id_cliente = null;
      }

      //items_unidades
    },

    configureMessages() {
      const dict = {
        email: {
          required: "O e-mail não pode ser vazio!",
          email: "É necessário informar um e-mail válido!"
        },
        nome: {
          required: "Nome não pode ser vazio!"
        }
        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },
    salvar() {
      var self = this;

      if (!this.validar()) return false;

      self.msg_status = "Salvando..";
      self.loading = true;

      if (this.form["nome"] == null) {
        //alert("Dado indo inválido!");
        //return;
      }

      service
        .salvar(this.form)
        .then(function(response) {
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "Usuário salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;

          self.form = item;

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;
      self.msg_status = "Excluindo..";
      self.loading = true;

      var fn_return = function(response) {
        var retorno = response.data;
        if (self.onSave != null && self.onSave != undefined) {
          self.onSave(retorno, "delete");
        }
        self.msg_status = "Carregando..";
        self.loading = false;
        self.botao_voltar();
      };
      if (this.form.id == null) return false;

      service.delete(this.form.id).then(fn_return);
      //	obj_api.call_delete("cliente", this.id, fn_return);
    },
    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>